import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'users',
  templateUrl: 'users.component.html',
  styleUrls: ['users.component.css'],
})

export class UsersBranch{

  constructor (private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit(){

    //Set the page title
    this.titleService.setTitle("WiseRisk | User Settings");

    var mainNav = "setting-nav";
		var sideNav = "side-nav-setting-user";
		/*<![CDATA[*/
		$(document).ready(function() {

			$("#splitter").jqxSplitter({
				width : '100%',
				height : 800,
				theme : 'bootstrap',
				panels : [{
					size : '30%'
				}]
			});
			// prepare the data
			var data = [{
				'name' : "Nick Leeson",
				'email' : 'nleeson@gam.com',
				'phone' : "+44 206 423 7212",
				'password' : "",
				'timezone' : "BST",
				'dateformat' : "dd/mm/yyyy",
				'timeformat24' : false,
				'numbergroupseparator' : ",",
				'numberdecimalseparator' : "."
			}, {
				'name' : "Jerome Kerviel",
				'email' : 'jkerviel@gam.com',
				'phone' : "+33 14254 2880",
				'password' : "",
				'timezone' : "CET",
				'dateformat' : "dd/mm/yyyy",
				'timeformat24' : false,
				'numbergroupseparator' : ".",
				'numberdecimalseparator' : ","
			}, {
				'name' : "John Rusnak",
				'email' : 'jrusnak@gam.com',
				'phone' : "+1 (410) 771-7214",
				'password' : "",
				'timezone' : "EST",
				'dateformat' : "mm/dd/yyyy",
				'timeformat24' : false,
				'numbergroupseparator' : ",",
				'numberdecimalseparator' : "."
			}, {
				'name' : "John Doe",
				'email' : 'jdoe@gam.com',
				'phone' : "+1 (858) 771-7209",
				'password' : "",
				'timezone' : "EST",
				'dateformat' : "mm/dd/yyyy",
				'timeformat24' : false,
				'numbergroupseparator' : ",",
				'numberdecimalseparator' : "."
			}];
			var source = {
				localdata : data,
				datatype : "json",
				updaterow : function(rowid, rowdata, commit) {
					commit(true);
				}
			};
			var dataAdapter = new $.jqx.dataAdapter(source);

			var updatePanel = function(datarecord) {
				$("#name").val(datarecord.name);
				$("#email").val(datarecord.email);
				$("#phone").val(datarecord.phone);
				$("#currentPassword").val(datarecord.password);
				$("#timeZone").val(datarecord.timezone);
				if (datarecord.timeformat24)
					$("input").val(["timeFormat"]);
				$("#dateFormat").val(datarecord.dateformat);
				$("#numberSeparator").val(datarecord.numberformat);
				$("#numberGroupSeparator").val(datarecord.numbergroupseparator);
				$("#numberDecimalSeparator").val(datarecord.numberdecimalseparator);
			}
			$('#jqxgrid').on('rowselect', function(event) {
				updatePanel(event.args.row);
			});

			$("#jqxgrid").jqxGrid({
				width : '100%',
				height : '100%',
				theme : 'bootstrap',
				source : dataAdapter,
				showfilterrow : true,
				filterable : true,
				columnsresize : true,
				showstatusbar : true,
				renderstatusbar : function(statusbar) {
					// appends buttons to the status bar.
					var container = $("<div style='overflow: hidden; position: relative; margin: 5px;'></div>");
					var addButton = $("<div style='float: left; margin-left: 5px;'>Add</div>");
					var deleteButton = $("<div style='float: left; margin-left: 5px;'>Delete</div>");
					container.append(addButton);
					container.append(deleteButton);
					statusbar.append(container);
					addButton.jqxButton();
					deleteButton.jqxButton();
					// add new row.
					addButton.click(function(event) {
						var datarow = [{
							'name' : "",
							'email' : '',
							'phone' : "",
							'password' : "",
							'timezone' : "",
							'dateformat' : "",
							'timeformat24' : false,
							'numbergroupseparator' : "",
							'numberdecimalseparator' : ""
						}];
						$("#jqxgrid").jqxGrid('addrow', null, datarow[0]);
						//this is really bad call; I couldn't find better way to do this
						//using this only for canned demo; we'll never use for large data set.
						var rowId = $("#jqxgrid").jqxGrid('getrows').length - 1;
						// 			                        rowId = $('#jqxgrid').jqxGrid('getrowid',rowId);

						$('#jqxgrid').jqxGrid('selectrow', rowId);
					});
					// delete selected row.
					deleteButton.click(function(event) {
						var selectedrowindex = $("#jqxgrid").jqxGrid('getselectedrowindex');
						var rowscount = $("#jqxgrid").jqxGrid('getdatainformation').rowscount;
						var id = $("#jqxgrid").jqxGrid('getrowid', selectedrowindex);
						$("#jqxgrid").jqxGrid('deleterow', id);
					});
				},
				columns : [{
					text : 'Name',
					datafield : 'name',
					width : '40%'
				}, {
					text : 'Email',
					datafield : 'email',
					width : '60%'
				}, ]
			});

			$('#jqxgrid').jqxGrid('selectrow', 0);

			$("#save").jqxButton({
				width : 70,
				height : 23
			});
			$("#save").click(function() {
				var row = $('#jqxgrid').jqxGrid('getselectedrowindex');
				var rowid = $("#jqxgrid").jqxGrid('getrowid', row);

				var data = {
					organizationId: $("#organization").val(),
					displayName : $("#name").val(),
					email : $("#email").val(),
					phone : $("#phone").val(),
					password : $("#password").val(),
					isChangePassword: $("#isChangePassword").is(":checked"),
					accessLevel: $("#accessLevel").val(),
					timezone : $("#timeZone").val(),
					timeformat24 : $("#timeFormat").val(),
					dateformat : $("#dateFormat").val(),
					dayDateFirst :$("#dayDateFirst").is(":checked"),
					numbergroupseparator : $("#numberGroupSeparator").val(),
					numberdecimalseparator : $("#numberDecimalSeparator").val(),
					enabled : $("#enabled").is(":checked")
				};
				//data = JSON.stringify(data);
				$.ajax({
					type : 'POST',
					url : '/ajax/user/users',
					headers : {
						'Accept' : 'application/json',
						'Content-Type' : 'application/json'
					},
					dataType : 'json',
					data : JSON.stringify(data),
					success : function(data) {
						alert("User Created Successfully!"); // show response from the php script.
						$("#jqxgrid").jqxGrid('updaterow', rowid, data);

					}
				});

				//$("#jqxgrid").jqxGrid('updaterow', rowid, data);


			});
		});
		/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/users/users.component.ts